export default __webpack_public_path__ + "static/media/nft2.23ca4a5f.png";